var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopMusicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.2.5C33.8.5.3,34,.3,75.3s33.5,74.8,74.8,74.8,74.8-33.5,74.8-74.8S116.5.5,75.2.5ZM76.1,136.8c-34,0-61.5-27.5-61.5-61.5S42.1,13.8,76.1,13.8s61.5,27.5,61.5,61.5-27.5,61.5-61.5,61.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.2,106.7l-.5.5c-1.2,1.2-3.3,1.2-4.5,0l-62.5-62.5c-1.2-1.2-1.2-3.3,0-4.5l.5-.5c1.2-1.2,3.3-1.2,4.5,0l16.4,16.4,17.1-17.2c2.4-2.5,6.6-.7,6.6,2.7v38.2l22.4,22.4c1.2,1.2,1.2,3.3,0,4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58,60.4l35.8,35.8v8.5c0,3.5-4.2,5.2-6.6,2.7l-20.9-21.1c-.5.3-1.1.5-1.7.5h-9.5c-1.7,0-3.1-1.4-3.1-3.1v-20.3c0-1.7,1.4-3.1,3.1-3.1h2.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopMusicIcon);
export default __webpack_public_path__ + "static/media/stop_music_icon.400fe928185858f335d86d0fa6c9238e.svg";
export { ForwardRef as ReactComponent };